import React from "react";
import PolicyLayout from "@/components/PolicyLayout";
export default function Terms() {
  return <PolicyLayout ns="terms" />;
}
